<div class="text-center text-white p-4 bg-dark">
    <i class="fas fa-circle-notch fa-spin fa-2x"></i> &nbsp;&nbsp;
    <span class="position-relative" style="font-size: 21px; top: -2px">
     {{ "GENERAL.ONE_MOMENT" | translate }}
    </span>
</div>